import React, { useEffect, useState, useRef } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Form,
  DatePicker,
  Message,
  Card,
  Pagination,
  Select,
  TimePicker,
  CascaderSelect,
} from '@alifd/next';

import moment from 'moment';
import axios from 'axios';

// import gasImg from "../../../../../public/gas.png";
import { Modal } from 'antd'; // dialog UI
import Swal from 'sweetalert2';
import Tab from '@/components/UI/mobile/Tab';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import ezconImg from '../../../../../public/ezcon.png';

const { Item } = Form;
const Option = Select.Option;
const { RangePicker, MonthPicker, YearPicker } = DatePicker;
const GasFrontDeskList = () => {
  // console.log("========props ",props)

  const gas = client.service('gas');
  const dd = new Date();
  const months =
    '一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月'.split(
      ','
    );
  const [gasArr, setGasArr] = useState([]);
  // console.log(gasArr)
  const [gasViewArr, setGasViewArr] = useState([]);
  const [userHouseholdNumber, setUserHouseholdNumber] = useState([]);

  // console.log(userHouseholdNumber)
  const [addGasDialog, setAddGasDialog] = useState(false);
  const [viewGasDialog, setViewGasDialog] = useState(false);
  const [householdNumber, setHouseholdNumber] = useState('');
  const [gasNumber, setGasNumber] = useState('');
  const [gasId, setGasId] = useState('');
  // const [gasMonth, setGasMonth] = useState('');
  const [usersHouseholdNumbers, setUsersHouseholdNumbers] = useState([]);
  const currentDate = moment();

  const [gasYear, setGasYear] = useState(dd.getFullYear().toString());
  const [gasMonth, setGasMonth] = useState(months[dd.getMonth()]);
  const [tab, setTab] = useState(0);
  // useEffect(() => {
  //   try {
  //     client.reAuthenticate().then((data) => {
  //       console.log('==setUsersHouseholdNumbers ok',data.user.householdNumbers)

  //       setUsersHouseholdNumbers(data.user.householdNumbers)
  //     })
  //   } catch
  //   (error) {
  //     console.log("未連接server:err", error)
  //   }

  // }, []);

  // 查詢
  function gasFind(para) {
    return new Promise((resolve, reject) => {
      try {
        gas.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  // 查詢id
  // const setGatArrId = (value, year, month) => {
  //   gas
  //     .find({
  //       query: {
  //         householdNumber: value,
  //         year,
  //         month,
  //       },
  //     })
  //     .then((result) => {
  //       if (result.total > 0) {
  //         setGasId(result.data[0]._id);
  //       }

  //       // console.log(result.data[0]._id);
  //     });
  // };

  // 刷新頁面
  function serverDataUpdate() {
    client.reAuthenticate().then((data) => {
      // console.log('==setUsersHouseholdNumbers ok',data.user.householdNumbers)

      setUsersHouseholdNumbers(
        !data.user.hasOwnProperty('householdNumbers') ||
          data.user.householdNumbers.length === 0
          ? false
          : data.user.householdNumbers
      );

      gas
        .find({
          query: {
            householdNumber: { $in: data.user.householdNumbers },
            $sort: {
              createdTime: -1,
            },
            // status: tab === 0 ? '未登記' : '已登記',
          },
        })
        .then((res) => {
          console.log('==gas find  success:', res.data);
          if (res.data[0].status === '已登記') {
            setGasId(res.data[0].gasNumber);
          } else if (
            res.data.length === 0 ||
            (res.data.length === 1 && res.data[0].status === '未登記')
          ) {
            setGasId('');
          } else if (res.data.length > 1 && res.data[0].status === '未登記') {
            for (let i = 1; i < res.data.length; i++) {
              if (res.data[i].gasNumber !== '') {
                setGasId(res.data[1].gasNumber);
                break;
              }
            }
          }

          setGasArr(res.data);
        })

        .catch((error) => {
          console.log('==gas find  fail:', error);
        });

      // setGatArrId(
      //   data.user.householdNumbers[0],
      //   dd.getFullYear().toString(),
      //   months[dd.getMonth()]
      // );
    });
  }

  useEffect(() => {
    serverDataUpdate();
  }, [tab]);

  // uploads files
  const [parsed, setParsed] = useState([]);
  const [parsed64, setParsed64] = useState([]); // Base64
  const uploadFile = useRef(null);

  function beforeUpload() {
    return new Promise((resolve, reject) => {
      (async () => {
        if (uploadFile.current.files.length > 0) {
          const isLt20M =
            (await uploadFile.current.files[0].size) / 1024 / 1024 < 20;

          if (!isLt20M) {
            Message.error('Image must smaller than 20MB!');
            return reject();
          }
          resolve(isLt20M);
        } else {
          setParsed64('');
        }
      })();
    });
  }

  const handleFiles = async () => {
    try {
      await beforeUpload();
      const files = [...parsed];
      const data = await uploadFile.current.files[0];
      // console.log(data)
      files.push(data);
      setParsed(files);

      // 轉Base64 上傳檔案後呈現沒有寫到DB
      const reader = new FileReader();
      reader.onload = function () {
        const dataURL = reader.result;
        setParsed64(dataURL);
      };
      reader.readAsDataURL(data);
    } catch (err) {
      console.log(err);
    }
  };

  // 今天以前日期禁止選
  // const disabledDate = (date, view) => {
  //   switch (view) {
  //     case 'date':
  //       return date.valueOf() <= currentDate.valueOf();
  //     case 'year':
  //       return date.year() < currentDate.year();
  //     case 'month':
  //       return date.year() * 100 + date.month() < currentDate.year() * 100 + currentDate.month();
  //     default: return false;
  //   }
  // };

  return (
    <>
      {/* 新增瓦斯度數 */}
      <Modal
        closable={false}
        mask={false}
        className={styles.dialog2}
        visible={addGasDialog}
        cancelText="取消"
        okText="送出"
        onOk={() => {
          if (!usersHouseholdNumbers) {
            Message.error('尚未開通戶號');
            return;
          }
          if (!gasNumber || gasNumber.length < 4) {
            Message.error('請填寫完整度數');
          } else {
            console.log(moment().year());
            console.log(months[moment().month()]);
            gas
              .find({
                query: {
                  householdNumber: usersHouseholdNumbers[0],
                  year: moment().year().toString(),
                  month: months[moment().month()],
                  $limit: 1,
                  // $sort: {
                  //   createdTime: -1,
                  // },
                },
              })
              .then((res) => {
                console.log(res);
                // 20220322 增加若本月已登記過則跳出提示並覆蓋紀錄
                if (res.total > 0) {
                  if (res.data[0].createdTime !== '') {
                    Swal.fire({
                      title: '本月已登記過度數',
                      text: '請確定抄錶度數，送出後將無法復原!!',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#BEBEBE',
                      confirmButtonText: '確定',
                      cancelButtonText: '取消',
                    }).then((gasResult) => {
                      if (gasResult.isConfirmed) {
                        if (
                          parseInt(gasNumber, 10) <
                            parseInt(res.data[0].gasNumber, 10) ||
                          parseInt(gasNumber, 10) ===
                            parseInt(res.data[0].gasNumber, 10)
                        ) {
                          Swal.fire({
                            title: `小於上一次度數:${res.data[0].gasNumber}`,
                            text: '請確定抄錶度數，送出後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire('成功!', '已新增抄錶度數', 'success');
                              const newObject = {
                                ...res.data[0],
                                updatedTime: new Date().getTime(),
                                createdTime: new Date().getTime(),
                                gasNumber,
                                status: '已登記',
                              };
                              gas
                                .patch(newObject._id, newObject)
                                .then(() => {
                                  serverDataUpdate();
                                  setParsed64('');
                                  setGasMonth(moment().format('MMMM'));
                                  setGasNumber('');
                                  setAddGasDialog(false);
                                  Message.success('新增成功');
                                })
                                .catch((error) => {
                                  Message.error(`${error}`);
                                });
                            }
                          });
                        } else {
                          Swal.fire({
                            title: `抄錶度數:${gasNumber}?`,
                            text: '請確定抄錶度數，送出後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire('成功!', '已新增抄錶度數', 'success');
                              const newObject = {
                                ...res.data[0],
                                updatedTime: new Date().getTime(),
                                createdTime: new Date().getTime(),
                                gasNumber,
                                status: '已登記',
                              };
                              gas
                                .patch(newObject._id, newObject)
                                .then(() => {
                                  serverDataUpdate();
                                  setParsed64('');
                                  setGasMonth(moment().format('MMMM'));
                                  setGasNumber('');
                                  setAddGasDialog(false);
                                  Message.success('新增成功');
                                })
                                .catch((error) => {
                                  Message.error(`${error}`);
                                });
                            }
                          });
                        }
                      }
                    });
                  } else {
                    Swal.fire('成功!', '已新增抄錶度數', 'success');
                    const newObject = {
                      ...res.data[0],
                      updatedTime: new Date().getTime(),
                      createdTime: new Date().getTime(),
                      gasNumber,
                      status: '已登記',
                    };
                    gas
                      .patch(newObject._id, newObject)
                      .then(() => {
                        serverDataUpdate();
                        setParsed64('');
                        setGasMonth(moment().format('MMMM'));
                        setGasNumber('');
                        setAddGasDialog(false);
                        Message.success('新增成功');
                      })
                      .catch((error) => {
                        Message.error(`${error}`);
                      });
                  }
                } else {
                  Swal.fire('成功!', '已新增抄錶度數', 'success');
                  gas
                    .create({
                      createdTime: new Date().getTime(),
                      updatedTime: new Date().getTime(),
                      householdNumber: usersHouseholdNumbers[0],
                      month: gasMonth,
                      year: gasYear,
                      gasNumber,
                      status: '已登記',
                    })

                    .catch((error) => {
                      console.log('==gas create fail:', error);
                      Message.error(`${error}`);
                    })
                    .then(() => {
                      console.log('==gas create result success:', res.data);
                      serverDataUpdate();
                      setParsed64('');
                      setGasMonth(moment().format('MMMM'));
                      setGasNumber('');
                      setAddGasDialog(false);
                      Message.success('新增成功');
                    });
                }
              })
              .catch((error) => {
                console.log('==gas find final data fail:', error);
              });
          }
        }}
        onCancel={() => {
          setAddGasDialog(false);
          setHouseholdNumber('');
          setGasNumber('');
          setParsed64('');
          setGasMonth(moment().format('MMMM'));
        }}
      >
        <Form>
          {/* <h3>抄錶登記</h3> */}

          <Item label="戶號">
            {usersHouseholdNumbers ? usersHouseholdNumbers[0] : '尚未開通戶號'}
          </Item>
          {gasId !== '' && <Item label="上次度數">{gasId}</Item>}

          {/* <Item label="期別" >
            <MonthPicker 
            disabledDate={disabledDate} 
            onChange={val => setGasMonth(moment(val).format("YYYY-MM"))} />
          </Item> */}
          <Item
            label="抄錶度數"
            required
            requiredMessage="必填"
            format="number"
            formatMessage="只限數字"
          >
            <Input
              maxLength={5}
              value={gasNumber}
              name="gasNumber"
              placeholder="請輸入度數"
              onChange={(value) => {
                // console.log('onChange', value);
                setGasNumber(value.replace(/\D/g, ''));
              }}
            />
          </Item>
          {/* <Item label="抄錶年份" required requiredMessage="必填">
            <Select
              defaultValue={dd.getFullYear().toString()}
              name="year"
              onChange={(value) => {
                setGasYear(value);
                setGatArrId(usersHouseholdNumbers[0], value, gasMonth);
              }}
            >
              <Option value={Number(dd.getFullYear() - 1).toString()}>
                {Number(dd.getFullYear() - 1).toString()}
              </Option>
              <Option value={dd.getFullYear().toString()}>
                {dd.getFullYear().toString()}
              </Option>
              <Option value={Number(dd.getFullYear() - 1).toString()}>
                {Number(dd.getFullYear() + 1).toString()}
              </Option>
            </Select>
          </Item> */}
          {/* <Item label="抄錶月份" required requiredMessage="必填">
            <Select
              value={gasMonth}
              name="month"
              onChange={(value) => {
                setGasMonth(value);
                setGatArrId(usersHouseholdNumbers[0], gasYear, value);
              }}
            >
              {months.map((x) => (
                <Option value={x}>{x}</Option>
              ))}
            </Select>
          </Item> */}
          <h3>瓦斯登記範例</h3>

          <img
            className={styles.img}
            src="img/image_gas meter.svg"
            alt="圖片"
          />

          <p>由左至右輸入度數，紅色區域不須填寫</p>

          {
            // { width: "50px", height: "50px" }
            parsed64.length > 0 ? (
              <img
                style={{ width: '21vw', height: '18vw' }}
                src={`${parsed64.length > 0 ? parsed64 : ezconImg}`}
                alt="圖片"
              />
            ) : null
          }
        </Form>
      </Modal>

      {/* 查看瓦斯抄錶 */}
      <Modal
        closable={false}
        mask={false}
        className={styles.dialog}
        visible={viewGasDialog}
        okText
        onOk={() => {
          setViewGasDialog(false);
        }}
        onCancel={() => {
          setViewGasDialog(false);
        }}
        cancelText="關閉"
      >
        {gasViewArr.map((item, index) => {
          return (
            <Form key={index}>
              <Item label="更新時間">
                {moment(item.updatedTime).format('YYYY-MM-DD HH:mm:ss')}
              </Item>
              <Item label="戶號">{item.householdNumber}</Item>
              <Item label="抄錶度數">{item.gasNumber}</Item>
              <Item label="抄錶年份">{item.year}</Item>
              <Item label="抄錶月份">{item.month}</Item>
              {item.files.length > 0 && item.files[0].length > 0 ? (
                <Item label="附加照片">
                  <img
                    style={{ width: '21vw', height: '18vw' }}
                    src={item.files[0]}
                    alt="圖片"
                  />
                </Item>
              ) : null}

              <Item label="狀態">{item.status}</Item>
            </Form>
          );
        })}
      </Modal>

      <div className={styles.mobileGas}>
        <div className={styles.mobileGasBackground} />
        <div className={styles.mainBtnBox}>
          <Button
            id={
              gasArr.filter(
                (item) => item.status === '未登記' || item.status === '已登記'
              ).length > 0
                ? styles.mainBtn
                : styles.mainDisableBtn
            }
            onClick={() => {
              setAddGasDialog(true);
            }}
            disabled={
              gasArr.filter(
                (item) => item.status === '未登記' || item.status === '已登記'
              ).length > 0
                ? false
                : true
            }
          >
            抄錶登記
          </Button>
        </div>
        <div className={styles.main} style={{ marginBottom: 10 }}>
          <Tab options={['當期度數', '歷史紀錄']} onChange={setTab} />
        </div>

        {gasArr
          .filter((item) => {
            if (tab === 0) {
              return item.status === '未登記' || item.status === '已登記';
            } else {
              return item.status === '已截止';
            }
          })
          .map((item, index) => {
            return (
              <div className={styles.main} key={index}>
                <div className={styles.flexItem}>
                  <div className={styles.bk}>
                    <span className={styles.head}>戶號</span>
                    <span className={styles.content}>
                      {item.householdNumber}
                    </span>
                  </div>

                  <div className={styles.bk}>
                    <div
                      className={
                        item.status === '未登記' || item.status === '已截止'
                          ? styles.rectRed
                          : styles.rectBlue
                      }
                    >
                      {item.status}
                    </div>
                  </div>
                </div>

                <div className={styles.flexItem}>
                  <div className={styles.bk}>
                    <span className={styles.head}>抄錶度數</span>
                    <span className={styles.content}>
                      {item.status === '未登記'
                        ? '尚未登記'
                        : item.gasNumber === ''
                        ? '未登記'
                        : item.gasNumber}
                    </span>
                  </div>
                </div>
                <div className={styles.flexItem}>
                  <div className={styles.bk}>
                    <span className={styles.head}>抄錶年份</span>
                    <span className={styles.content}>{item.year}</span>
                  </div>
                </div>
                <div className={styles.flexItem}>
                  <div className={styles.bk}>
                    <span className={styles.head}>抄錶月份</span>
                    <span className={styles.content}>{item.month}</span>
                  </div>
                </div>
                {item.createdTime !== '' ? (
                  <div className={styles.flexItem}>
                    <div className={styles.bk}>
                      <span className={styles.head2}>
                        {`更新日期:${moment(item.updatedTime).format(
                          'YYYY-MM-DD HH:mm:ss'
                        )}`}
                      </span>
                    </div>
                  </div>
                ) : null}
                <div className={styles.flexItem}>
                  <div className={styles.bk}>
                    <span className={styles.head2}>
                      {`截止日期:${moment(item.endTime).format(
                        'YYYY-MM-DD HH:mm:ss'
                      )}`}
                    </span>
                  </div>
                </div>
                {index !==
                  gasArr.filter((item) => {
                    if (tab === 0) {
                      return (
                        item.status === '未登記' || item.status === '已登記'
                      );
                    } else {
                      return item.status === '已截止';
                    }
                  }).length -
                    1 && <hr className={styles.bcolor} />}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default GasFrontDeskList;
